export default __webpack_public_path__ + "static/media/sticker-15.099ae140.png";